/**
 * Convert preact-router splat paths (`/:rest*`) to react-router-dom v6 (`/*`).
 * bookList keeps legacy path strings for backwards compatibility in tests.
 */
export const toReactRouterPath = (path) => path.replace(/\/:rest\*$/, '/*');
